import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'

class DataTableBloc {

    rowtableChannel = new Subject();
    rowtableAdminChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    detailChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({ status: apiResponse.INITIAL })
    }

    fetchRowTableAdmin = async (query, cancelToken) => {
        this.rowtableAdminChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchRowTableAdmin(query, cancelToken).then((result) => {
                this.rowtableAdminChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableAdminChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchActive = async (query) => {
        this.activeChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchActive(query).then((result) => {
                this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.activeChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default DataTableBloc